import { memo, useCallback } from "react";

import PlayerCompareItemView from "./PlayerCompareItemView";

import { PlayerCardData } from "@/types/playerCardTypes";

/**
 * Props for the PlayerCompareItem container component
 */
interface PlayerCompareItemContainerProps {
  item: PlayerCardData;
  index: number;
  isSmallScreen: boolean;
  onSelectComparePlayer: (player: PlayerCardData) => void;
}

/**
 * Container component for a single player item in the compare list.
 * Handles the press callback and memoization to prevent unnecessary re-renders.
 * @param root0 - Component props
 * @param root0.item - The player data
 * @param root0.index - Index of the item in the list
 * @param root0.isSmallScreen - Whether the screen is small (mobile)
 * @param root0.onSelectComparePlayer - Callback when player is selected
 */
const PlayerCompareItemContainer = memo(function PlayerCompareItemContainer({
  item,
  index,
  isSmallScreen,
  onSelectComparePlayer,
}: PlayerCompareItemContainerProps) {
  const handlePress = useCallback(() => {
    onSelectComparePlayer(item);
  }, [onSelectComparePlayer, item]);

  return (
    <PlayerCompareItemView
      item={item}
      index={index}
      isSmallScreen={isSmallScreen}
      onPress={handlePress}
    />
  );
});

export default PlayerCompareItemContainer;
